import React, { useState } from 'react'
import { Button, Col, Form, FormProps, Input, Modal, ModalProps, Row, Select, useSelect, message, Grid } from '@pankod/refine-antd'
import { DatePicker } from 'antd'
import { IReportTheme } from 'interfaces'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import { findProjectFieldName } from 'gql/query'

interface ICreateProject {
  formProps: FormProps
  modalProps: ModalProps
  refetchData: () => void
  close: any
}
const ProjectCreate: React.FC<ICreateProject> = ({ formProps, modalProps, refetchData, close }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { RangePicker } = DatePicker
  //fetching details
  // const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
  //   resource: 'report_themes',
  //   fetchSize: 10000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  //for start date
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    return current && current < dayjs().add(0, 'day')
  }

  //submiting values
  const onSubmit = async (values: any) => {
    try {
      if (values && values?.name?.trim() && values?.duration?.length === 2) {
        const duration: { start_date?: string; end_date?: string } = {}
        //formating the duration of the project
        duration.start_date = values.duration[0].format('DD-MM-YYYY') || ''
        duration.end_date = values.duration[1].format('DD-MM-YYYY') || ''
        values.name = values?.name?.trim().toLowerCase() || ''
        values.duration = duration
        values.report_theme_ids = values?.report_theme_ids || []
        //checking the name is repeated or not?
        const isPresent: any = await findProjectFieldName(values.name.toLowerCase(), 'name','project_config')
        //if its not repeated then
        if (isPresent && isPresent?.project_config?.length === 0) {
          return formProps.onFinish && formProps.onFinish(values)
        } else {
          message.error('Project name is already present... please make sure projects are unique')
        }
      } else {
        message.error('values are not present')
      }
    } catch (err) {
      message.error('Something went wrong.. please try again later...')
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const breakpoint = Grid.useBreakpoint()
  const isMobile = !breakpoint.lg
  return (
    <Modal
      {...modalProps}
      title="Create Project"
      onCancel={() => close()}
      footer={[
        <Button key="submit" type="primary" onClick={() => formProps?.form?.submit()} loading={loading} style={{ width: !isMobile ? '20%' : '50%' }}>
          Save Project
        </Button>,
      ]}
    >
      <Form
        {...formProps}
        onFinish={values =>
          onSubmit(values)
            .then((res: any) => {
              if (res?.data?.id) {
                message.success('Item added successfully')
              }
            })
            .catch(err => {
              message.error('Something went wrong please try again later...')
            })
            .finally(() => {
              formProps?.form?.resetFields()
              close()
            })
        }
      >
        <Row gutter={[24, 0]}>
          <Col xs={24} lg={8}>
            {/* project name */}
            <Form.Item
              label="Project Name"
              name="name"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: 'Please add an name',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          {/* description */}
          <Col xs={24} lg={8}>
            <Form.Item label="Description" name="description" labelCol={{ span: 24 }}>
              <Input />
            </Form.Item>
          </Col>
          {/* date */}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Duration"
              name="duration"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: 'please select the project duration' }]}
            >
              <RangePicker format="DD-MM-YYYY" disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          {/* report theme */}
          {/* <Col xs={24} lg={24}>
            <Form.Item label="Report Themes" name="report_theme_ids" labelCol={{ span: 24 }}>
              <Select {...reportThemeProps} mode="multiple" />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </Modal>
  )
}

export default ProjectCreate
